import {
    ConvertedCurrencyValue,
    FlexItemNoShrink,
    FlexSpaceBetweenAlignCenter,
    LocalizedDateFromUtc,
    SpacedLongDash,
    SpacedPipe,
    SpacingSmallLeft,
} from '@mews-commander/ui';
import { Typography, Stack } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { Reservation } from '@mews-commander/data-access';
import { ReservationTimeState, ServiceOrderState } from '@mews-commander/legacy-data-structures';
import { ServiceName } from '../../../../../../../components/commander-ui';
import { AccountFullName } from '../../../../../components/AccountFullName';
import { TotalAmountAndCount } from '../../../../../types';
import { ReservationStateTag } from '../../../../../../../components/reservation/ReservationStateTag';
import { SpaceOrderName } from './SpaceOrderName';

interface SpaceOrderLabelProps {
    reservation: Reservation;
    serviceId: string;
    booker?: string;
    totalAmountAndCount: TotalAmountAndCount;
}

export const SpaceOrderLabel: React.FC<SpaceOrderLabelProps> = ({
    reservation,
    serviceId,
    booker,
    totalAmountAndCount,
}) => {
    const { accountId, number, timeState, options, state, startUtc, endUtc, assignedResourceId, channelNumber } =
        reservation;

    const { unitCount, amount } = totalAmountAndCount;
    return (
        <>
            {timeState != null && state != null && (
                <ReservationStateTag
                    timeState={ReservationTimeState.getByValue(timeState)}
                    options={options}
                    state={ServiceOrderState.getByValue(state)}
                />
            )}
            <SpacingSmallLeft />
            <FlexSpaceBetweenAlignCenter>
                <Stack wrap>
                    <Typography textStyle="bodyMediumStrong" as="div">
                        {accountId && <AccountFullName accountId={accountId} />}
                        {SpacedLongDash}
                    </Typography>
                    {assignedResourceId ? (
                        <Typography textStyle="bodyMediumStrong" as="div">
                            <SpaceOrderName serviceId={serviceId} resourceId={assignedResourceId} />
                        </Typography>
                    ) : null}
                    <Typography textStyle="bodyMediumStrong" as="div">
                        <Stack wrap>
                            <LocalizedDateFromUtc utcString={startUtc} />
                            {SpacedLongDash}
                            <LocalizedDateFromUtc utcString={endUtc} />
                        </Stack>
                    </Typography>
                    <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
                        {SpacedLongDash}
                        <ServiceName id={serviceId} /> {number}
                        {booker ? (
                            <>
                                {SpacedPipe}
                                {booker}
                            </>
                        ) : null}
                        {SpacedLongDash}
                        {channelNumber ? (
                            <>
                                {channelNumber}
                                {SpacedLongDash}
                            </>
                        ) : null}
                        {unitCount}
                        {UnicodeEntity.MultiplicationSign}
                    </Typography>
                </Stack>
                <FlexItemNoShrink>
                    <ConvertedCurrencyValue amount={amount} />
                </FlexItemNoShrink>
            </FlexSpaceBetweenAlignCenter>
        </>
    );
};
